import React from "react";
import "./EasyBuySummary.css";
import { useTranslation } from "react-i18next";
import EasyBuySummaryDetails from "./EasyBuySummaryDetails";

const EasyBuySummary = ({ isApplyBPlusNewDeviceDiscount = false, easyBuySummaryData, setEasyBuySummaryData }) => {

  const { t } = useTranslation();

  return (
    <div className="easybuy-summary-container">
      <h3 className="summary-title">{t("EASY_BUY_SUMMARY.TITLE")}</h3>

      <EasyBuySummaryDetails isApplyBPlusNewDeviceDiscount={isApplyBPlusNewDeviceDiscount} easyBuySummaryData={easyBuySummaryData} setEasyBuySummaryData={setEasyBuySummaryData}></EasyBuySummaryDetails>
    </div>
  );
};

export default EasyBuySummary;
